import api from "../utils/api";
import { isGuid } from "../utils/string";
import {
  LOGOUT
} from "./types";

export const save = ({ uuid, retainer, subject, status, stage, nextFollowUpAt, lastContactedAt, lastActivityAt, probability, estimatedValue, lostReason, convertedAt, convertedClientUuid, source, sourceDetail, assignedToUuid, budget, primaryArea, secondaryArea, timeline, intent, fit, rates, minutes, caseLocationUuid, CaseLocation, meta  }) => async (dispatch) => {
    try {
        const res = await api.post(`/leads`, { uuid, retainer, subject, status, stage, nextFollowUpAt, lastContactedAt, lastActivityAt, probability, estimatedValue, lostReason, convertedAt, convertedClientUuid, source, sourceDetail, assignedToUuid, budget, primaryArea, secondaryArea, timeline, intent, fit, rates, minutes, caseLocationUuid, CaseLocation, meta  });
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const destroy = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.delete(`/leads/i/${uuid}`) : { data: { success: false }} ;
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const get = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.get(`/leads/i/${uuid}`) : { data: { success: false }} ;
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const activities = ({ leadUuid }) => async (dispatch) => {
    try {
        const res = isGuid(leadUuid) ? await api.get(`/leads/activities/l/${leadUuid}`) : { data: { items: [], success: false }} ;
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const workQueue = ({ mine = true } = {}) => async (dispatch) => {
    try {
        const res = await api.get(mine ? `/leads/me` : `/leads/work-queue`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const list = ({ page = 0, size = 25, order = "updatedAt", direction = "DESC", search = "", status = "OPEN", stage, source, assignedToUuid, unassigned = false, overdue = false } = {}) => async (dispatch) => {
    try {
        const res = await api.get(`/leads/list`, {
            params: {
                page,
                size,
                order,
                direction,
                search,
                status,
                stage,
                source,
                assignedToUuid,
                unassigned,
                overdue
            }
        });
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const analytics = () => async (dispatch) => {
    try {
        const res = await api.get(`/leads/analytics`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const saveActivity = ({ uuid, leadUuid, type, occurredAt, dueAt, completedAt, assignedToUuid, subject, body, meta, updateFutureFollowUps = false }) => async (dispatch) => {
    try {
        const res = await api.post(`/leads/activities`, { uuid, leadUuid, type, occurredAt, dueAt, completedAt, assignedToUuid, subject, body, meta, updateFutureFollowUps });
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const completeActivity = ({ uuid, ensureFollowUp = false }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.put(`/leads/activities/i/${uuid}/complete`, { ensureFollowUp }) : { data: { success: false }} ;
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const snoozeActivity = ({ uuid, days = 1 }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.put(`/leads/activities/i/${uuid}/snooze`, { days }) : { data: { success: false }} ;
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const deleteActivity = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.delete(`/leads/activities/i/${uuid}`) : { data: { success: false }} ;
        return res.data;
    } catch (error) {
        if (error?.response?.status === 401) {
            dispatch({
                type: LOGOUT
            });
            return;
        }

        return error?.response?.data || {
            success: false,
            error: {
                message: "The lead activity could not be deleted."
            }
        };
    }
}

export const convert = ({ uuid, createMatter = false, matterCaption, matterStyle, matterFlags } = {}) => async (dispatch) => {
    try {
        const res = isGuid(uuid)
            ? await api.post(`/leads/i/${uuid}/convert`, { createMatter, matterCaption, matterStyle, matterFlags })
            : { data: { success: false } };
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const updateStage = ({ uuid, stage, status } = {}) => async (dispatch) => {
    try {
        const res = isGuid(uuid)
            ? await api.put(`/leads/i/${uuid}/stage`, { stage, status })
            : { data: { success: false } };
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const assign = ({ leadUuids = [], assignedToUuid = null } = {}) => async (dispatch) => {
    try {
        const res = await api.post(`/leads/assign`, { leadUuids, assignedToUuid });
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}
